import t from "@ext/localization/locale/translate";
import { Button } from "@ui-kit/Button";

interface CatalogViewFooterProps {
	onCancel: () => void;
}

export const CatalogViewFooter = ({ onCancel }: CatalogViewFooterProps) => {
	return (
		<>
			<Button className="w-full" onClick={onCancel} size="xs" type="button" variant="outline">
				{t("cancel")}
			</Button>
			{/* Not disabled on an empty name: pressing it runs the form's own validation, which puts the
			    reason under the field where the fix is, instead of leaving a dead button and no words. */}
			<Button className="w-full" size="xs" type="submit" variant="primary">
				{t("save")}
			</Button>
		</>
	);
};
